import { render, staticRenderFns } from "./dupDevList.vue?vue&type=template&id=07cca9e8"
import script from "./dupDevList.vue?vue&type=script&lang=js"
export * from "./dupDevList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports